import Vue from 'vue'
import { mapActions, mapMutations, mapState } from 'vuex'
import ArchivedTab from './ArchivedTab/ArchivedTab.vue'
import FreelanceTab from './FreelanceTab/FreelanceTab.vue'
import FullTimeTab from './FullTimeTab/FullTimeTab.vue'
import debounce from 'lodash/debounce'
import { CHAT, CHAT_ARCHIVED, CHAT_FULL_TIME } from '@/constants/routes'
import unreadMessagesBlinkTitleMixin from '@/mixins/unreadMessagesBlinkTitleMixin'
import { RootState } from '@/store'

export default Vue.extend<any, any, any, any>({
  mixins: [unreadMessagesBlinkTitleMixin],
  computed: {
    ...mapState<RootState>({
      search: (state: RootState) => state.chatNew.search,
    }),
    tabs() {
      return [
        {
          title: 'Freelance',
          component: FreelanceTab,
          to: { name: CHAT, query: { chatSearch: this.$route.query.chatSearch } },
        },
        {
          title: 'Full-time',
          component: FullTimeTab,
          to: { name: CHAT_FULL_TIME, query: { chatSearch: this.$route.query.chatSearch } },
        },
        {
          title: 'Archived',
          component: ArchivedTab,
          to: { name: CHAT_ARCHIVED, query: { chatSearch: this.$route.query.chatSearch } },
        },
      ]
    },
  },
  async mounted() {
    const querySearch = this.$route.query.chatSearch
    const queryParamExists = !!querySearch

    // If we have query search param, we will do search
    if (queryParamExists) {
      this.setSearch(querySearch)
      await this.loadAllRooms()
      this.setLastSearch(querySearch)
    }

    // Reset for page transitions from chat button
    if (this.search !== '' && !queryParamExists) {
      this.setSearch('')
      await this.loadAllRooms()
      this.setLastSearch('')
    }
  },
  methods: {
    ...mapMutations({
      setSearch: 'chatNew/setSearch',
      setLastSearch: 'chatNew/setLastSearch',
    }),
    ...mapActions({
      loadFreelanceRooms: 'chatNew/loadMoreFreelanceRooms',
      loadVacanciesRooms: 'chatNew/loadMoreVacanciesRooms',
      loadArchivedRooms: 'chatNew/loadMoreArchivedRooms',
    }),
    async loadAllRooms() {
      await this.loadFreelanceRooms({})
      await this.loadVacanciesRooms({})
      await this.loadArchivedRooms({})
    },
    onInputSearch(value: string) {
      this.$router.push({ query: { ...this.$route.query, chatSearch: value } })
      this.setSearch(value)
      this.loadRoomsDebounce(value)
    },
    loadRoomsDebounce: debounce(async function (search: string) {
      await this.loadAllRooms()
      this.setLastSearch(search)
    }, 500),
  },
  metaInfo() {
    return {
      title: this.getMetaTitle('Chat'),
    }
  },
})
